import { useLocale } from "next-intl";
import type { CountryType } from "../@types/generic";

export const useCountry = (): CountryType => {
    const locale = useLocale();
    return locale.split("-")[1]?.toLowerCase() as CountryType;
};
